import React from 'react';
import { X, ArrowLeft } from 'lucide-react';
import Logo from './Logo';

const CONTENT = {
  vi: {
    terms: {
      title: 'Điều Khoản Sử Dụng',
      lastUpdated: 'Cập nhật lần cuối: Tháng 4, 2026',
      sections: [
        {
          title: '1. Giới Thiệu',
          content: `Chào mừng bạn đến với Claw9.ai ("Dịch vụ"), được vận hành bởi CÔNG TY TNHH CLAW9 VIỆT NAM ("Công ty", "chúng tôi"). Bằng việc truy cập hoặc sử dụng Dịch vụ, bạn đồng ý tuân thủ các Điều khoản Sử dụng này ("Điều khoản").

Nếu bạn không đồng ý với bất kỳ phần nào của Điều khoản này, vui lòng không sử dụng Dịch vụ.`
        },
        {
          title: '2. Mô Tả Dịch Vụ',
          content: `Claw9.ai cung cấp nền tảng AI Agent tự động hóa chăm sóc khách hàng và bán hàng thông qua các kênh nhắn tin như Zalo, Facebook Messenger, và các nền tảng khác. Dịch vụ bao gồm:

• Chatbot AI tự động trả lời tin nhắn
• Quản lý khách hàng (CRM)
• Tích hợp với các kênh nhắn tin
• Phân tích và báo cáo
• Huấn luyện AI thông qua FAQ`
        },
        {
          title: '3. Đăng Ký Tài Khoản',
          content: `Để sử dụng Dịch vụ, bạn cần:

• Cung cấp thông tin chính xác và đầy đủ khi đăng ký
• Bảo mật thông tin đăng nhập của bạn
• Chịu trách nhiệm về mọi hoạt động diễn ra trên tài khoản của bạn
• Thông báo cho chúng tôi ngay khi phát hiện truy cập trái phép

Bạn phải từ 18 tuổi trở lên hoặc có sự đồng ý của phụ huynh/người giám hộ để sử dụng Dịch vụ.`
        },
        {
          title: '4. Quyền và Nghĩa Vụ Của Người Dùng',
          content: `Khi sử dụng Dịch vụ, bạn đồng ý:

• Không sử dụng Dịch vụ cho mục đích bất hợp pháp
• Không gửi tin nhắn spam hoặc quấy rối người khác
• Không vi phạm quyền sở hữu trí tuệ của bất kỳ bên nào
• Không cố gắng truy cập trái phép vào hệ thống
• Không sử dụng Dịch vụ để phát tán nội dung độc hại, lừa đảo
• Tuân thủ các quy định của Zalo OA và các nền tảng khác mà bạn tích hợp`
        },
        {
          title: '5. Thanh Toán và Đăng Ký',
          content: `• Các gói dịch vụ được thanh toán theo tháng hoặc năm
• Phí dịch vụ có thể thay đổi với thông báo trước 30 ngày
• Không hoàn tiền cho các khoản thanh toán đã thực hiện, trừ trường hợp đặc biệt
• Tài khoản sẽ bị tạm ngưng nếu không thanh toán đúng hạn
• Bạn có thể hủy đăng ký bất cứ lúc nào, dịch vụ sẽ tiếp tục đến hết chu kỳ thanh toán`
        },
        {
          title: '6. Quyền Sở Hữu Trí Tuệ',
          content: `• Claw9.ai và tất cả nội dung, tính năng, công nghệ thuộc sở hữu của Công ty
• Bạn giữ quyền sở hữu đối với dữ liệu, nội dung bạn tải lên Dịch vụ
• Bạn cấp cho chúng tôi quyền sử dụng dữ liệu của bạn để cung cấp và cải thiện Dịch vụ
• Không được sao chép, phân phối, hoặc tạo sản phẩm phái sinh từ Dịch vụ mà không có sự đồng ý bằng văn bản`
        },
        {
          title: '7. Giới Hạn Trách Nhiệm',
          content: `Dịch vụ được cung cấp "nguyên trạng" (as is). Chúng tôi không đảm bảo:

• Dịch vụ sẽ không bị gián đoạn hoặc không có lỗi
• Kết quả từ việc sử dụng Dịch vụ sẽ chính xác 100%
• AI sẽ trả lời đúng trong mọi trường hợp

Trong mọi trường hợp, trách nhiệm của chúng tôi không vượt quá số tiền bạn đã thanh toán cho Dịch vụ trong 12 tháng trước đó.`
        },
        {
          title: '8. Chấm Dứt',
          content: `Chúng tôi có quyền tạm ngưng hoặc chấm dứt tài khoản của bạn nếu:

• Vi phạm các Điều khoản này
• Không thanh toán phí dịch vụ
• Sử dụng Dịch vụ gây hại cho người khác hoặc hệ thống

Bạn có thể chấm dứt tài khoản bất cứ lúc nào bằng cách liên hệ với chúng tôi.`
        },
        {
          title: '9. Luật Áp Dụng',
          content: `Các Điều khoản này được điều chỉnh bởi pháp luật Việt Nam. Mọi tranh chấp sẽ được giải quyết tại Tòa án có thẩm quyền tại Thành phố Hồ Chí Minh, Việt Nam.`
        },
        {
          title: '10. Liên Hệ',
          content: `Nếu có thắc mắc về Điều khoản này, vui lòng liên hệ:

CÔNG TY TNHH CLAW9 VIỆT NAM
Địa chỉ: 104 Mai Thị Lựu, Phường Tân Định, TP. Hồ Chí Minh
Email: support@claw9.ai`
        }
      ]
    },
    privacy: {
      title: 'Chính Sách Bảo Mật',
      lastUpdated: 'Cập nhật lần cuối: Tháng 4, 2026',
      sections: [
        {
          title: '1. Giới Thiệu',
          content: `CÔNG TY TNHH CLAW9 VIỆT NAM ("Công ty", "chúng tôi") cam kết bảo vệ quyền riêng tư của bạn. Chính sách Bảo mật này giải thích cách chúng tôi thu thập, sử dụng, chia sẻ và bảo vệ thông tin cá nhân của bạn khi sử dụng dịch vụ Claw9.ai.`
        },
        {
          title: '2. Thông Tin Chúng Tôi Thu Thập',
          content: `Chúng tôi thu thập các loại thông tin sau:

**Thông tin bạn cung cấp:**
• Thông tin đăng ký: họ tên, email, số điện thoại, tên công ty
• Thông tin thanh toán: thông tin thẻ, địa chỉ thanh toán
• Nội dung: FAQ, dữ liệu sản phẩm, tin nhắn bạn cấu hình cho chatbot

**Thông tin tự động thu thập:**
• Dữ liệu sử dụng: thời gian truy cập, tính năng sử dụng, tương tác
• Thông tin thiết bị: loại trình duyệt, địa chỉ IP, hệ điều hành
• Cookies và công nghệ theo dõi tương tự

**Thông tin từ bên thứ ba:**
• Dữ liệu từ Zalo, Facebook khi bạn kết nối tài khoản
• Tin nhắn của khách hàng gửi qua các kênh đã kết nối`
        },
        {
          title: '3. Cách Chúng Tôi Sử Dụng Thông Tin',
          content: `Chúng tôi sử dụng thông tin của bạn để:

• Cung cấp, vận hành và cải thiện Dịch vụ
• Xử lý thanh toán và quản lý tài khoản
• Gửi thông báo về dịch vụ, cập nhật, bảo mật
• Huấn luyện và cải thiện mô hình AI
• Phân tích xu hướng và hiệu suất
• Hỗ trợ khách hàng
• Phát hiện và ngăn chặn gian lận, lạm dụng
• Tuân thủ các yêu cầu pháp lý`
        },
        {
          title: '4. Chia Sẻ Thông Tin',
          content: `Chúng tôi có thể chia sẻ thông tin của bạn với:

• **Nhà cung cấp dịch vụ:** các bên hỗ trợ vận hành (hosting, thanh toán, phân tích)
• **Đối tác tích hợp:** Zalo, Facebook, Google khi bạn kết nối dịch vụ
• **Theo yêu cầu pháp lý:** khi được yêu cầu bởi cơ quan có thẩm quyền
• **Chuyển nhượng kinh doanh:** trong trường hợp sáp nhập, mua lại

Chúng tôi KHÔNG bán thông tin cá nhân của bạn cho bên thứ ba.`
        },
        {
          title: '5. Bảo Mật Dữ Liệu',
          content: `Chúng tôi áp dụng các biện pháp bảo mật:

• Mã hóa dữ liệu truyền tải (SSL/TLS)
• Mã hóa dữ liệu lưu trữ
• Kiểm soát truy cập nghiêm ngặt
• Giám sát bảo mật 24/7
• Sao lưu dữ liệu định kỳ
• Đào tạo nhân viên về bảo mật

Tuy nhiên, không có phương thức truyền tải hoặc lưu trữ nào an toàn 100%. Chúng tôi không thể đảm bảo tuyệt đối an ninh thông tin.`
        },
        {
          title: '6. Quyền Của Bạn',
          content: `Bạn có quyền:

• **Truy cập:** Yêu cầu bản sao thông tin cá nhân của bạn
• **Chỉnh sửa:** Cập nhật thông tin không chính xác
• **Xóa:** Yêu cầu xóa thông tin cá nhân (với một số ngoại lệ)
• **Từ chối:** Từ chối nhận email tiếp thị
• **Di chuyển:** Nhận dữ liệu ở định dạng có thể chuyển đổi
• **Khiếu nại:** Liên hệ cơ quan bảo vệ dữ liệu nếu có lo ngại

Để thực hiện các quyền này, vui lòng liên hệ: support@claw9.ai`
        },
        {
          title: '7. Lưu Trữ Dữ Liệu',
          content: `• Chúng tôi lưu trữ dữ liệu trong thời gian bạn sử dụng Dịch vụ
• Sau khi hủy tài khoản, dữ liệu sẽ được xóa trong vòng 90 ngày
• Một số dữ liệu có thể được giữ lại để tuân thủ pháp luật hoặc giải quyết tranh chấp
• Tin nhắn khách hàng được lưu trữ theo cài đặt của bạn`
        },
        {
          title: '8. Cookies',
          content: `Chúng tôi sử dụng cookies để:

• Duy trì phiên đăng nhập
• Ghi nhớ tùy chọn của bạn
• Phân tích cách bạn sử dụng Dịch vụ
• Cải thiện trải nghiệm người dùng

Bạn có thể tắt cookies trong trình duyệt, nhưng một số tính năng có thể không hoạt động đúng.`
        },
        {
          title: '9. Trẻ Em',
          content: `Dịch vụ không dành cho người dưới 18 tuổi. Chúng tôi không cố ý thu thập thông tin từ trẻ em. Nếu phát hiện đã thu thập thông tin từ trẻ em, chúng tôi sẽ xóa ngay.`
        },
        {
          title: '10. Thay Đổi Chính Sách',
          content: `Chúng tôi có thể cập nhật Chính sách này theo thời gian. Các thay đổi quan trọng sẽ được thông báo qua email hoặc trên Dịch vụ. Việc tiếp tục sử dụng Dịch vụ sau khi thay đổi đồng nghĩa với việc bạn chấp nhận Chính sách mới.`
        },
        {
          title: '11. Liên Hệ',
          content: `Nếu có câu hỏi về Chính sách Bảo mật, vui lòng liên hệ:

CÔNG TY TNHH CLAW9 VIỆT NAM
Địa chỉ: 104 Mai Thị Lựu, Phường Tân Định, TP. Hồ Chí Minh
Email: privacy@claw9.ai`
        }
      ]
    }
  },
  en: {
    terms: {
      title: 'Terms of Service',
      lastUpdated: 'Last updated: April 2026',
      sections: [
        {
          title: '1. Introduction',
          content: `Welcome to Claw9.ai ("Service"), operated by CLAW9 VIETNAM CO., LTD ("Company", "we", "us"). By accessing or using the Service, you agree to be bound by these Terms of Service ("Terms").

If you do not agree to any part of these Terms, please do not use the Service.`
        },
        {
          title: '2. Service Description',
          content: `Claw9.ai provides an AI Agent platform that automates customer service and sales through messaging channels such as Zalo, Facebook Messenger, and other platforms. The Service includes:

• AI chatbot for automated message responses
• Customer relationship management (CRM)
• Integration with messaging channels
• Analytics and reporting
• AI training through FAQs`
        },
        {
          title: '3. Account Registration',
          content: `To use the Service, you must:

• Provide accurate and complete information during registration
• Keep your login credentials secure
• Be responsible for all activities that occur under your account
• Notify us immediately upon discovering unauthorized access

You must be 18 years or older or have parental/guardian consent to use the Service.`
        },
        {
          title: '4. User Rights and Obligations',
          content: `By using the Service, you agree to:

• Not use the Service for illegal purposes
• Not send spam or harass others
• Not infringe on any party's intellectual property rights
• Not attempt unauthorized access to the system
• Not use the Service to distribute harmful or fraudulent content
• Comply with regulations of Zalo OA and other platforms you integrate`
        },
        {
          title: '5. Payment and Subscription',
          content: `• Service plans are billed monthly or annually
• Service fees may change with 30 days prior notice
• No refunds for payments made, except in special circumstances
• Accounts will be suspended if payment is not made on time
• You may cancel your subscription at any time; service will continue until the end of the billing cycle`
        },
        {
          title: '6. Intellectual Property',
          content: `• Claw9.ai and all content, features, and technology are owned by the Company
• You retain ownership of data and content you upload to the Service
• You grant us the right to use your data to provide and improve the Service
• You may not copy, distribute, or create derivative works from the Service without written consent`
        },
        {
          title: '7. Limitation of Liability',
          content: `The Service is provided "as is". We do not guarantee:

• The Service will be uninterrupted or error-free
• Results from using the Service will be 100% accurate
• AI will respond correctly in all cases

In all cases, our liability shall not exceed the amount you paid for the Service in the preceding 12 months.`
        },
        {
          title: '8. Termination',
          content: `We reserve the right to suspend or terminate your account if you:

• Violate these Terms
• Fail to pay service fees
• Use the Service in ways that harm others or the system

You may terminate your account at any time by contacting us.`
        },
        {
          title: '9. Governing Law',
          content: `These Terms are governed by the laws of Vietnam. Any disputes shall be resolved at the competent court in Ho Chi Minh City, Vietnam.`
        },
        {
          title: '10. Contact',
          content: `If you have questions about these Terms, please contact:

CLAW9 VIETNAM CO., LTD
Address: 104 Mai Thi Luu, Tan Dinh Ward, Ho Chi Minh City
Email: support@claw9.ai`
        }
      ]
    },
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: April 2026',
      sections: [
        {
          title: '1. Introduction',
          content: `CLAW9 VIETNAM CO., LTD ("Company", "we", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, share, and protect your personal information when using Claw9.ai.`
        },
        {
          title: '2. Information We Collect',
          content: `We collect the following types of information:

**Information you provide:**
• Registration information: name, email, phone number, company name
• Payment information: card details, billing address
• Content: FAQs, product data, messages you configure for the chatbot

**Automatically collected information:**
• Usage data: access times, features used, interactions
• Device information: browser type, IP address, operating system
• Cookies and similar tracking technologies

**Information from third parties:**
• Data from Zalo, Facebook when you connect your account
• Customer messages sent through connected channels`
        },
        {
          title: '3. How We Use Information',
          content: `We use your information to:

• Provide, operate, and improve the Service
• Process payments and manage accounts
• Send service notifications, updates, and security alerts
• Train and improve AI models
• Analyze trends and performance
• Provide customer support
• Detect and prevent fraud and abuse
• Comply with legal requirements`
        },
        {
          title: '4. Information Sharing',
          content: `We may share your information with:

• **Service providers:** parties that help us operate (hosting, payment, analytics)
• **Integration partners:** Zalo, Facebook, Google when you connect services
• **Legal requirements:** when required by competent authorities
• **Business transfers:** in case of merger or acquisition

We DO NOT sell your personal information to third parties.`
        },
        {
          title: '5. Data Security',
          content: `We implement security measures including:

• Data encryption in transit (SSL/TLS)
• Data encryption at rest
• Strict access controls
• 24/7 security monitoring
• Regular data backups
• Employee security training

However, no transmission or storage method is 100% secure. We cannot guarantee absolute information security.`
        },
        {
          title: '6. Your Rights',
          content: `You have the right to:

• **Access:** Request a copy of your personal information
• **Correction:** Update inaccurate information
• **Deletion:** Request deletion of personal information (with some exceptions)
• **Opt-out:** Opt out of marketing emails
• **Portability:** Receive data in a transferable format
• **Complain:** Contact data protection authorities if you have concerns

To exercise these rights, please contact: support@claw9.ai`
        },
        {
          title: '7. Data Retention',
          content: `• We retain data while you use the Service
• After account cancellation, data will be deleted within 90 days
• Some data may be retained for legal compliance or dispute resolution
• Customer messages are stored according to your settings`
        },
        {
          title: '8. Cookies',
          content: `We use cookies to:

• Maintain login sessions
• Remember your preferences
• Analyze how you use the Service
• Improve user experience

You can disable cookies in your browser, but some features may not work properly.`
        },
        {
          title: '9. Children',
          content: `The Service is not intended for anyone under 18 years old. We do not knowingly collect information from children. If we discover we have collected information from a child, we will delete it immediately.`
        },
        {
          title: '10. Policy Changes',
          content: `We may update this Policy from time to time. Significant changes will be notified via email or on the Service. Continued use of the Service after changes means you accept the new Policy.`
        },
        {
          title: '11. Contact',
          content: `If you have questions about this Privacy Policy, please contact:

CLAW9 VIETNAM CO., LTD
Address: 104 Mai Thi Luu, Tan Dinh Ward, Ho Chi Minh City
Email: privacy@claw9.ai`
        }
      ]
    }
  }
};

// Full Page View Component
export const TermsPage = ({ language = 'vi', onBack }) => {
  const t = CONTENT[language]?.terms || CONTENT.vi.terms;

  return (
    <div className="min-h-screen bg-[#050810] text-white">
      {/* Header */}
      <header className="sticky top-0 z-50 border-b border-white/10 bg-[#050810]/95 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <button
            onClick={onBack}
            className="p-2 rounded-lg hover:bg-white/5 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <Logo size="small" />
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-2">{t.title}</h1>
        <p className="text-white/50 mb-10">{t.lastUpdated}</p>

        <div className="space-y-8">
          {t.sections.map((section, index) => (
            <section key={index}>
              <h2 className="text-xl font-semibold text-[#ff4d4d] mb-3">
                {section.title}
              </h2>
              <div className="text-white/70 whitespace-pre-wrap leading-relaxed">
                {section.content}
              </div>
            </section>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-8 px-6 mt-12">
        <div className="max-w-4xl mx-auto text-center text-white/40 text-sm">
          © 2026 Claw9.ai. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export const PrivacyPage = ({ language = 'vi', onBack }) => {
  const t = CONTENT[language]?.privacy || CONTENT.vi.privacy;

  return (
    <div className="min-h-screen bg-[#050810] text-white">
      {/* Header */}
      <header className="sticky top-0 z-50 border-b border-white/10 bg-[#050810]/95 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <button
            onClick={onBack}
            className="p-2 rounded-lg hover:bg-white/5 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <Logo size="small" />
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-2">{t.title}</h1>
        <p className="text-white/50 mb-10">{t.lastUpdated}</p>

        <div className="space-y-8">
          {t.sections.map((section, index) => (
            <section key={index}>
              <h2 className="text-xl font-semibold text-[#ff4d4d] mb-3">
                {section.title}
              </h2>
              <div className="text-white/70 whitespace-pre-wrap leading-relaxed">
                {section.content}
              </div>
            </section>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-8 px-6 mt-12">
        <div className="max-w-4xl mx-auto text-center text-white/40 text-sm">
          © 2026 Claw9.ai. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

// Modal View Component (alternative for showing within landing page)
export const LegalModal = ({ isOpen, onClose, type = 'terms', language = 'vi' }) => {
  if (!isOpen) return null;

  const content = type === 'terms'
    ? (CONTENT[language]?.terms || CONTENT.vi.terms)
    : (CONTENT[language]?.privacy || CONTENT.vi.privacy);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4">
      <div className="w-full max-w-3xl max-h-[90vh] overflow-hidden rounded-2xl border border-white/10 bg-[#050810] shadow-2xl flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 flex-shrink-0">
          <div>
            <h2 className="text-xl font-semibold text-white">{content.title}</h2>
            <p className="text-sm text-white/50">{content.lastUpdated}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-white/5 text-white/60 hover:text-white transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6 py-6">
          <div className="space-y-6">
            {content.sections.map((section, index) => (
              <section key={index}>
                <h3 className="text-lg font-semibold text-[#ff4d4d] mb-2">
                  {section.title}
                </h3>
                <div className="text-sm text-white/70 whitespace-pre-wrap leading-relaxed">
                  {section.content}
                </div>
              </section>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-white/10 flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full px-4 py-2.5 bg-[#ff4d4d] hover:bg-[#ff5c5c] text-white rounded-lg font-medium transition-colors"
          >
            {language === 'vi' ? 'Đã hiểu' : 'I understand'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default { TermsPage, PrivacyPage, LegalModal };
